export default __webpack_public_path__ + "static/media/Others.e26371ad.svg";